import { forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "../utils/moment";

interface Props {
  value: Date | null;
  onChange: (value: Date | null) => void;
  label?: string;
}

const Toggle = forwardRef<HTMLButtonElement, any>(
  ({ value, onClick, label, hasValue, onClear }, ref) => (
    <button
      ref={ref}
      type="button"
      className="sortPill__toggle"
      onClick={onClick}
    >
      <i className="bi bi-calendar3" aria-hidden="true" />
      <span className="sortPill__label">{label}</span>
      <span className="sortPill__sep">·</span>
      <span className="sortPill__value">
        {hasValue ? value : "All time"}
      </span>
      {hasValue ? (
        <i
          className="bi bi-x-circle-fill sortPill__chevron"
          aria-hidden="true"
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            onClear();
          }}
        />
      ) : (
        <i
          className="bi bi-chevron-down sortPill__chevron"
          aria-hidden="true"
        />
      )}
    </button>
  )
);

const MonthYearFilter: React.FC<Props> = ({
  value,
  onChange,
  label = "Month",
}) => {
  const display = value ? moment(value).format("MMM YYYY") : "";

  return (
    <div className="sortPill">
      <DatePicker
        selected={value}
        onChange={(date: Date | null) => onChange(date)}
        showMonthYearPicker
        dateFormat="MMM yyyy"
        popperPlacement="bottom-end"
        maxDate={new Date()}
        customInput={
          <Toggle
            value={display}
            label={label}
            hasValue={!!value}
            onClear={() => onChange(null)}
          />
        }
      />
    </div>
  );
};

export default MonthYearFilter;
